
/* APPLICATION ROUTE CONSTANTS */

module.exports = Object.freeze({
  
    ROW_PER_PAGE : [10, 50, 100, 300, 500],
    ROW_REPORT_PER_PAGE : [50,100, 200, 300, 400, 500],

    // Status
    STATUS_REGISTER:'Register',

    /* Routers Link supplier_app */
    APP_HOME: '/hb-login',
    HOME: '/home',
    
    HOME_INTRO:'/customer-intro',
    DASHBOARD: '/customer-dashboard',
    INBOX: '/customer-inbox',
    OUTBOX: '/customer-outbox',

    // -----------------------------------------  CUSTOMER_V4  --------------------------------------------
 
    //HB
    CUSTOMER_V4_HB_HOME_PAGE:'/hb-home-page',
    CUSTOMER_V4_HB_LOGIN: "/hb-login",
 
    //Employee
    CUSTOMER_V4_HB_EMPLOYEE: "/hb-employee",
 
    CUSTOMER_V4_HB_ESTIMATE_LIST:'/hb-estimate-list',


    CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN: "/material-price-breakdown",
    CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN_DETAILS: "/material-price-breakdown-detail",
   
    CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN: "/customer-sales-breakdown",
    CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN_DETAILS: "/customer-salesbreakdown-details",
 
    CUSTOMER_V4_QUOTATION_ESTIMATE: "/quotation-estimate",
    CUSTOMER_V4_QUOTATION_ESTIMATE_DETAILS: "/quotation-estimate-details",
   
    CUSTOMER_V4_FINANCE_PRICE_BREAKDOWN_CREATION: "/finance-price-breakdown-creation",

    CUSTOMER_V4_HB_MATERIAL_LIST: "/hb-material-List",

    CUSTOMER_V4_CUSTOMER_ESTIMATE_E1: "/customer-estimate-specification",
    CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION: "/customer-estimate-creation",
    CUSTOMER_V4_CUSTOMER_ESTIMATE_MATERIAL_DETAILS: "/customer-estimate-material-details",

    CUSTOMER_V4_HB_QUOTATION_LIST: "/hb-quotation-list",
    CUSTOMER_V4_HB_ENTRY_LIST: "/hb-entry-list",

    CUSTOMER_V4_HB_JOB_LIST: "/hb-job-list",
    
    CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_LIST:"/hb-estimation-list",
    
    CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS:"/hb-estimation-details",
    CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_DETAILS_REVISION:"/hb-estimation-revision",
    CUSTOMER_V4_CUSTOMER_ESTIMATE_SPECIFICATION_WORKFLOW: "/customer-estimate-specification-workflow",
    CUSTOMER_V4_CUSTOMER_ESTIMATE_CREATION__WORKFLOW: "/customer-estimate-creation-workflow",

    //REPORTS
CUSTOMER_REPORTS:'/customer-reports',
CUSTOMER_REPORT_DETAILS:'/customer-report-details',
 
})  

